document.addEventListener("DOMContentLoaded", function () {

  const grid = document.querySelector("#collection-grid");
  const trigger = document.querySelector("#infinite-trigger");

  if (!grid || !trigger) return;

  const observer = new IntersectionObserver(async (entries) => {

    if (!entries[0].isIntersecting) return;

    observer.unobserve(trigger);

    const nextUrl = trigger.dataset.nextUrl;
    if (!nextUrl) return;

    try {
      const response = await fetch(nextUrl);
      const text = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");

      const newItems = doc.querySelector("#collection-grid").innerHTML;
      grid.insertAdjacentHTML("beforeend", newItems);

      const newTrigger = doc.querySelector("#infinite-trigger");

      if (newTrigger) {
        trigger.dataset.nextUrl = newTrigger.dataset.nextUrl;
        observer.observe(trigger);
      } else {
        trigger.remove();
      }

    } catch (error) {
      console.error(error);
    }

  }, {
    rootMargin: "300px"
  });

  observer.observe(trigger);
});